import React from 'react'
import AudioPlayer from '../../components/AudioPlayer.jsx/AudioPlayer'


const renderMultimedia = (data) => {
    var viewData
    const file = data.files ? data.files : data
    if (file.type) {
        if (file.type.includes('image') || file.type.includes('gif')) {
            viewData =
                <img alt="img" className='img-post-view' src={file.url.origin} />
        }
        if (file.type.includes('video'))
            viewData =
                <video preload="auto" className="video-post-view" controls>
                    <source src={file.url.origin}></source>
                </video>
        if (file.type.includes('audio'))
            viewData =
                <div className='parent-width'>
                    <AudioPlayer url={file.url.origin}/>
                </div>
        return (
            viewData
        )
    } else return <div></div>
}
const renderStory = (storyID) => {
    return (
        <div className="multimedia-messages">
            {storyID.multimedia[0].type.includes('image') &&
                <img alt="img" className='img-post-view' src={storyID.multimedia[0].url.origin} />
            }
            {storyID.multimedia[0].type.includes('video') &&
                <video preload="auto" className="video-post-view" controls>
                    <source src={storyID.multimedia[0].url.origin}></source>
                </video>
            }
        </div>
    )
}

export { renderMultimedia ,renderStory}